<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="['byggnad', 'byggnader', 'Ny byggnad']"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('buildings_edit')"
			@toggleAdd="toggleAddBuilding"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view" @click="closeAdd()">
			<BuildingList
				:buildings="buildings"
				:activeBuilding="activeBuilding"
				@delete="askToDeleteBuilding"
				@edit="editBuilding"
				@search="getBuildings()"
				@navigate="navigate"
			/>

			<ui-alert v-if="error" error class="column">{{ error }}</ui-alert>
		</main>
		<AddBuilding
			v-if="showAddBuilding"
			@save="saveBuilding"
			@cancel="closeAdd"
			:editBuilding="selectedBuilding"
		/>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BuildingList from './components/BuildingList';
import AddBuilding from './modals/AddBuilding';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		BuildingList,
		AddBuilding,
		DeleteModal,
		TopPanel
	},
	data() {
		return {
			showAddBuilding: false,
			showAddFloor: false,
			showDelete: false,
			selectedBuilding: {},
			activeBuilding: {},
			orderBys: [
				{ name: 'Namn', value: 'Name' },
				{ name: 'Skapad', value: 'Created' }
			],
			error: ''
		};
	},
	computed: {
		...mapState('buildingStore', ['searchParams']),
		...mapState('floorStore', { floorSearchParams: 'searchParams' }),
		...mapGetters('appStore', ['isMobile']),
		...mapGetters('buildingStore', ['buildings', 'building', 'pagination']),
		...mapGetters('floorStore', ['floors']),
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return `Är du säker på att du vill ta bort ${this.selectedBuilding.name}?`;
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.searchParams.customerId = this.getActiveCustomer?.id;
			this.getBuildings();
			this.activeBuilding = {};
		}
	},

	created() {
		this.searchParams.customerId = this.getActiveCustomer?.id;
		this.getBuildings();
	},

	methods: {
		...mapActions('buildingStore', [
			'getBuildings',
			'getBuilding',
			'createBuilding',
			'updateBuilding',
			'deleteBuilding',
			'setCurrentPage',
			'setPageSize'
		]),
		...mapActions('floorStore', [
			'setFloor',
			'getFloors',
			'createFloor',
			'updateFloor',
			'deleteFloor'
		]),
		...mapActions('mapStore', ['setMaps', 'createMap']),
		...mapActions('mapItemStore', ['setMapItems']),

		toggleAddBuilding() {
			if (!this.selectedBuilding.name) {
				this.showAddBuilding = !this.showAddBuilding;
			}

			this.selectedBuilding = {};
			this.showAddFloor = false;
		},

		closeAdd() {
			if (window.getSelection().toString() == '') {
				this.showAddBuilding = false;
				this.selectedBuilding = {};
			}

			if (this.showDelete) {
				this.showDelete = false;
				this.selectedBuilding = {};
			}
		},

		async saveBuilding(building) {
			this.error = '';

			if (this.selectedBuilding.id) {
				await this.updateBuilding(building).then(() => {
					this.selectedBuilding = {};
				});
			} else {
				building.customerId = this.getActiveCustomer?.id;

				await this.$services.building.createBuilding(building)
					.catch(err => this.error = err.message);
			}

			this.showAddBuilding = false;
			await this.getBuildings();
		},

		editBuilding(building) {
			if (this.selectedBuilding == building) {
				this.selectedBuilding = {};
				this.showAddBuilding = false;
			} else {
				this.selectedBuilding = building;
				this.showAddBuilding = true;
				this.showAddFloor = false;
			}
		},

		askToDeleteBuilding(building) {
			this.showAddFloor = false;
			this.showAddBuilding = false;
			Object.assign(this.selectedBuilding, building);
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedBuilding = {};
		},

		deleteSelected() {
			this.deleteBuilding(this.selectedBuilding).then(() => {
				this.showDelete = false;
				this.selectedBuilding = {};
			});
		},

		search(searchValue) {
			this.searchParams.name = searchValue;
			this.getBuildings();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getBuildings();
		},

		paginate(page) {
			this.setCurrentPage(page);
			this.getBuildings();
		},

		updatePageSize(size) {
			this.setPageSize(size);
			this.setCurrentPage(1);
			this.getBuildings();
		},

		navigate(id) {
			this.$router.push({
				name: 'BuildingDetailView',
				params: {
					buildingId: id
				}
			});
		},

		selectBuilding(building) {
			if (this.activeBuilding.id == building.id) {
				this.activeBuilding = {};
			} else {
				this.activeBuilding = Object.assign({}, building);
			}

			this.floorSearchParams.buildingId = this.activeBuilding.id;
			this.getFloors();
		}
	}
};
</script>
